export class AppError<T extends string> extends Error {
  code: T;

  constructor(code: T) {
    super();
    this.code = code;
  }
}
